import { render, staticRenderFns } from "./TeachTableDisplayPanel.vue?vue&type=template&id=60784f9e"
import script from "./TeachTableDisplayPanel.vue?vue&type=script&lang=js"
export * from "./TeachTableDisplayPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports